import axios from 'axios'
import { TIME_OUT } from './config'

const service = axios.create({
  timeout: TIME_OUT,
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  (config) => {
    config.params = config.params || {}
    config.headers = config.headers || {}
    return config
  },
  (error) => ({ status: 0, msg: error.message })
)

service.interceptors.response.use(
  (response) => {
    const resp = response.data
    if (response.status === 200) {
      if (resp.code === 200) {
        return resp
      } else {
        return Promise.reject(resp)
      }
    } else {
      return Promise.reject(resp)
    }
  },
  (err) => {
    return Promise.reject(err.response)
  }
)

function request(method = 'GET', url, data) {
  return new Promise((resolve, reject) => {
    let config = {
      method,
      url,
      ...data
    }
    return service(config)
      .then((res) => {
        /// 在这里就把data解析并返回
        resolve(res.data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

const get = function (url, params) {
  return request('GET', url, { params }).catch((err) => {
    throw err
  })
}

const post = function (url, data) {
  return request('POST', url, { data }).catch((err) => {
    throw err
  })
}

export { get, post }
